import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/multiLocationSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const FilterLevelFirstSelect = () => {
  const dispatch = useDispatch();

  const filter_levels = useSelector((state) => state.multiLocation.availableFilters.filter_levels);
  const options = useSelector((state) => state.multiLocation.availableFilters.level_1);
  const selectedOptions = useSelector((state) => state.multiLocation.selectedLevelFirst);

  const title = useSelector((state) => state.multiLocation.availableFilters.filter_titles[0]);

  return filter_levels.includes("level_1") ? (
    <>
      <p>{title}</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedOptions}
        placeholder="Please Select"
        enableOnly
        numberDisplayed={0}
        includeSelectAll
        onSelectChange={(data) =>
          dispatch(actionCreators.updateFiltersRequest({ name: "FilterLevelFirst", data: data }))
        }
      />
    </>
  ) : null;
};

export default FilterLevelFirstSelect;
